/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
// @ts-nocheck
import { makeRequest } from "@/utils/axiosInterceptor";

async function getAnalyticsData() {
	try {
		const accessRoute = '/analytics/dashboard'
		const { data: dashboardMetrics } = await makeRequest("GET", accessRoute, "");
        console.log('Dashboard metrics:', dashboardMetrics)
		return dashboardMetrics;
	} catch (error) {
		console.error("Error fetching dashboard metrics:", error);
		// Return fallback data if API fails
		return {
			storage: {
				totalGB: 0,
				instances: 0,
			},
			studies: {
				total: 0,
				recent: 0,
			},
			reports: {
				total: 0,
				recent: 0,
				completed: 0,
				pending: 0,
				completionRate: 0,
			},
			aiAnalysis: {
				totalAnalyses: 0,
				abnormalFindings: 0,
				tbDetections: 0,
				detectionRate: 0,
			},
			users: {
				total: 0,
			},
		};
	}
}
export default getAnalyticsData; 